export class MessageReference {
    constructor(public discussionId: number, public messageId: number) {}
}
